import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/aboutus',
    name: 'aboutus',
    component: Home
  }, {
    path: '/product',
    name: 'product',
    component: Home
  }, {
    path: '/contect',
    name: 'contect',
    component: Home
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js